var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M19.324 13.486a.4.4 0 0 1-.083-.239v-2.492c0-.086.029-.17.083-.238l1.15-1.44a1.65 1.65 0 0 0 .139-1.853l-.67-1.16a1.65 1.65 0 0 0-1.674-.806l-1.821.277a.4.4 0 0 1-.25-.048L14.04 4.241a.4.4 0 0 1-.165-.199l-.672-1.708a1.645 1.645 0 0 0-1.53-1.047h-1.345a1.645 1.645 0 0 0-1.53 1.047l-.675 1.708a.4.4 0 0 1-.166.193L5.795 5.487a.4.4 0 0 1-.25.048l-1.817-.277a1.65 1.65 0 0 0-1.673.806l-.67 1.16a1.65 1.65 0 0 0 .14 1.852l1.149 1.44a.4.4 0 0 1 .082.24v2.491c0 .087-.028.171-.082.24l-1.15 1.44a1.65 1.65 0 0 0-.139 1.851l.67 1.16a1.65 1.65 0 0 0 1.673.807l1.822-.277a.4.4 0 0 1 .25.048l2.157 1.246a.4.4 0 0 1 .166.192l.672 1.715a1.65 1.65 0 0 0 1.53 1.047h1.341a1.65 1.65 0 0 0 1.53-1.047l.673-1.715a.4.4 0 0 1 .165-.192l2.158-1.246a.4.4 0 0 1 .25-.048l1.821.277a1.65 1.65 0 0 0 1.673-.806l.67-1.16a1.65 1.65 0 0 0-.139-1.853zm-8.325 1.96a3.444 3.444 0 1 1 0-6.889 3.444 3.444 0 0 1 0 6.888Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.d321a0e7c3eeba6127f76283f63b3999.svg";
export { ForwardRef as ReactComponent };